module.exports = __webpack_public_path__ + "img/kh.34480cc9.svg";